import './CompactCalendar.css';
export default {
    "compactCalendarContainer": "CompactCalendar_compactCalendarContainer__t266c",
    "compactDateGrid": "CompactCalendar_compactDateGrid__t266c",
    "compactChoiceCardContainer": "CompactCalendar_compactChoiceCardContainer__t266c"
};
